<p-dialog
  header="Recuperar Contraseña"
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  styleClass="forget-password-dialog"
  [style]="{ width: '40vw' }"
  [breakpoints]="{ '1199px': '50vw', '767px': '75vw', '575px': '92vw' }"
  (onHide)="resetComponentState()"
>
  <span class="text-gray-500 block mb-2">Ingrese el correo electrónico para buscar su cuenta y enviar el código de confirmación</span>

  <form [formGroup]="recoverAccountForm" *ngIf="this.stepCodeToRecoverPassword === 1">
    <div class="grid grid-cols-12 gap-4 mt-3">
      <div class="col-span-12">
        <label for="username" class="text-sm font-medium block mb-1">Correo Electrónico <span class="text-red-500">*</span></label>
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-user"></i>
          </p-inputGroupAddon>
          <input id="username" type="text" placeholder="Correo Electrónico" pInputText class="w-full" formControlName="email" />
        </p-inputGroup>
        <ng-container *ngFor="let validation of validationMessages.email">
          <small
            class="validation-error"
            *ngIf="
              recoverAccountForm.get('email')?.hasError(validation.type) && (recoverAccountForm.get('email')?.dirty || recoverAccountForm.get('email')?.touched)
            "
          >
            {{ validation.msg }}
          </small>
        </ng-container>
        <!-- Botón de inicio de sesión con spinner de carga -->
        <div class="flex justify-center mt-2">
          <button
            pButton
            pRipple
            label="Enviar Código y Continuar"
            icon="pi pi-arrow-right"
            iconPos="right"
            severity="info"
            class="w-full"
            [loading]="loading"
            [disabled]="recoverAccountForm.status == 'INVALID' || this.loading"
            (click)="requestCodeToConfirmAccount()"
          ></button>
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="requestCodeForm" *ngIf="stepCodeToRecoverPassword === 2">
    <div class="grid grid-cols-12 gap-4 w-full">
      <!-- Código de Confirmación -->
      <div class="col-span-12">
        <label for="code" class="text-sm font-medium block mb-1">Código de Confirmación <span class="text-red-500">*</span></label>
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-key"></i>
          </p-inputGroupAddon>
          <input id="code" type="text" pInputText class="w-full" formControlName="code" placeholder="Código de Confirmación" />
        </p-inputGroup>
        <ng-container *ngFor="let validation of validationMessages.code">
          <small
            class="validation-error"
            *ngIf="requestCodeForm.get('code')?.hasError(validation.type) && (requestCodeForm.get('code')?.dirty || requestCodeForm.get('code')?.touched)"
          >
            {{ validation.msg }}
          </small>
        </ng-container>
      </div>

      <!-- Nueva Contraseña -->
      <div class="col-span-12">
        <label for="newPassword" class="text-sm font-medium block mb-1">Nueva Contraseña <span class="text-red-500">*</span></label>
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-lock"></i>
          </p-inputGroupAddon>
          <input id="newPassword" [type]="passwordFieldType" class="w-full" formControlName="newPassword" pInputText placeholder="Nueva Contraseña" />
          <p-inputGroupAddon (click)="togglePasswordVisibility()">
            <i [ngClass]="passwordFieldType === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
          </p-inputGroupAddon>
        </p-inputGroup>
        <ng-container *ngFor="let validation of validationMessages.newPassword">
          <small
            class="validation-error"
            *ngIf="
              requestCodeForm.get('newPassword')?.hasError(validation.type) &&
              (requestCodeForm.get('newPassword')?.dirty || requestCodeForm.get('newPassword')?.touched)
            "
          >
            {{ validation.msg }}
          </small>
        </ng-container>
      </div>

      <!-- Confirmación de la Contraseña -->
      <div class="col-span-12">
        <label for="confirmNewPassword" class="text-sm font-medium block mb-1">Confirmar Contraseña <span class="text-red-500">*</span></label>
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-lock"></i>
          </p-inputGroupAddon>
          <input
            id="confirmNewPassword"
            [type]="passwordFieldType"
            class="w-full"
            formControlName="confirmNewPassword"
            pInputText
            placeholder="Confirmar Contraseña"
          />
          <p-inputGroupAddon (click)="togglePasswordVisibility()">
            <i [ngClass]="passwordFieldType === 'password' ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
          </p-inputGroupAddon>
        </p-inputGroup>
        <ng-container *ngFor="let validation of validationMessages.confirmNewPassword">
          <small
            class="validation-error"
            *ngIf="
              requestCodeForm.get('confirmNewPassword')?.hasError(validation.type) &&
              (requestCodeForm.get('confirmNewPassword')?.dirty || requestCodeForm.get('confirmNewPassword')?.touched)
            "
          >
            {{ validation.msg }}
          </small>
        </ng-container>
      </div>

      <!-- Botón para confirmar la nueva contraseña -->
      <div class="col-span-12 mt-4">
        <button
          pButton
          label="Confirmar Contraseña"
          icon="pi pi-check"
          iconPos="left"
          severity="success"
          class="w-full"
          [loading]="loading"
          [disabled]="requestCodeForm.status === 'INVALID' || loading"
          (click)="validateCodeAndConfirmReset()"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
